"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkIcon = void 0;
const React = __importStar(require("react"));
const BookmarkIcon = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 13, height: 18, fill: "none" }, props),
    React.createElement("path", { stroke: "#E84E1B", strokeWidth: 1.5, d: "m1.094 1.106.007-.007c.227-.246.47-.349.759-.349h9.28c.288 0 .532.103.759.349.234.253.351.542.351.901v14.31c0 .228-.223.38-.427.315l-4.909-3.25L6.5 13.1l-.414.274-4.908 3.249a.326.326 0 0 1-.428-.314V2c0-.368.113-.65.344-.894Z" })));
exports.BookmarkIcon = BookmarkIcon;
